import { motion } from "framer-motion";
import { scrollToSection } from "@/components/Navbar";

export default function CtaStrip({ id = "1" }) {
  return (
    <section className="relative py-16 lg:py-20 border-t border-[#D4AF37]/10" data-testid={`cta-strip-${id}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 lg:flex lg:items-center lg:justify-between gap-10">
        <motion.h3
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
          className="font-display text-2xl sm:text-3xl lg:text-4xl font-light tracking-tight text-[#F5F5F5]"
          data-testid={`cta-strip-${id}-headline`}
        >
          Ready to <span className="italic text-[#D4AF37]">break ground?</span>
        </motion.h3>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-8 lg:mt-0 flex flex-wrap gap-4"
        >
          <button
            onClick={() => scrollToSection("#contact")}
            data-testid={`cta-strip-${id}-estimate-button`}
            className="bg-[#D4AF37] text-black px-7 py-3.5 text-[10px] tracking-[0.26em] uppercase font-medium hover:bg-[#F3E5AB] transition-colors duration-300"
          >
            Request a Project Estimate
          </button>
          <button
            onClick={() => scrollToSection("#contact")}
            data-testid={`cta-strip-${id}-consultation-button`}
            className="border border-white/25 text-[#F5F5F5] px-7 py-3.5 text-[10px] tracking-[0.26em] uppercase hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300"
          >
            Schedule a Consultation
          </button>
          <a
            href="tel:+18164056181"
            data-testid={`cta-strip-${id}-call-button`}
            className="border border-[#D4AF37]/40 text-[#D4AF37] px-7 py-3.5 text-[10px] tracking-[0.26em] uppercase hover:bg-[#D4AF37] hover:text-black transition-colors duration-300"
          >
            Discuss Your Project
          </a>
        </motion.div>
      </div>
    </section>
  );
}
